import { InjectionToken } from '@angular/core';
import { IMockService } from '@shared/interfaces/certify/imock-service';
import { IRestInfraestructureService } from '@shared/interfaces/rest/IRestInfraestructureService';

export const HANDLER_REQUEST = new InjectionToken<IRestInfraestructureService>('HANDLER_REQUEST');
export const HANDLER_MOCK_REQUEST = new InjectionToken<IMockService>('HANDLER_MOCK_REQUEST');
